import { useEffect, useRef, useCallback } from "react";

let lock = false;
const useListScroll = (data, callback, filter) => {
  let ref = useRef(null);
  useEffect(() => {
    if (data) {
      lock = data.some( x => x.load );
    }
  }, [data])
  const onScroll = useCallback((e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight * 3;
    if (bottom && !lock && filter === '') {
      lock = true;
      if (callback) { callback(); };
    }
  }, [callback, filter]);

  return { ref, onScroll };
};

export default useListScroll;
